import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const CompanyService = {
  async downloadCompanyImage(blobname) {
    return await ApiService.get(`api/CompanyImage/${blobname}/download`);
  },
  async getByCompanyCode(code, params) {
    const requestScreenData = {
      url: "api/Company",
      top: "1",
      filter: `Code eq '${code}'`,
    };

    if (params) {
      if (params.select) {
        requestScreenData.select = params.select;
      }
    }

    return await ApiService.oDataGet(requestScreenData);
  },
  async getCompany(params) {
    const requestScreenData = {
      url: "api/Company",
      top: "1",
    };

    if (params) {
      if (params.select) {
        requestScreenData.select = params.select;
      }
    }

    return await ApiService.oDataGet(requestScreenData);
  },
  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },
  async save(payload) {
    var url = "api/Company";

    return await ApiService.post(url, payload, "Guid");
  },
  async getCompanyCurrencyData(code) {
    const requestScreenData = {
      url: "api/CompanyCurrencyData",
      top: "1",
      filter: `CompanyCode eq '${code}'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
};

export { CompanyService };
